<div class="button-with-overlay-help">
    @if (!popup?.hideIcon) {
        <div class="help-overlay"
             (mouseenter)="onHelpEnter()"
             (mouseleave)="onHelpLeave()">
            <button mat-icon-button
                    class="help-button"
                    #helpTrigger="matMenuTrigger"
                    [matMenuTriggerFor]="helpMenu"
                    [matMenuTriggerRestoreFocus]="false">
                <mat-icon class="help-icon">help</mat-icon>
            </button>

            <mat-menu #helpMenu="matMenu"
                      [yPosition]="'above'"
                      [xPosition]="'after'"
                      [hasBackdrop]="false">
                <div class="help-content"
                     (mouseenter)="onHelpEnter()"
                     (mouseleave)="onHelpLeave()"
                     (click)="$event.stopPropagation()">
                    <p class="help-description">{{ popup.description }}</p>

                    @if (!popup.buttonIsHidden) {
                        <button mat-raised-button
                                class="full-width"
                                [disabled]="popup.disabled"
                                color="primary"
                                (click)="onPopupClick($event)">
                            {{ popup.buttonText }}
                        </button>
                    }
                </div>
            </mat-menu>
        </div>
    }
</div>
